import CanvasBasedRenderSpace from "./canvas-based-render-space";
import { navigateStage } from "../utils";
import AnimateProxyBase from "../animate-proxys/animate-proxy-base";

/**
 *  * @category Render Spaces
 */
export class AnimateRenderSpace extends CanvasBasedRenderSpace {
  protected manageBounds = false;
  protected flaName: string;
  protected _exportRootProxy: AnimateProxyBase;
  protected rootStageObject: createjs.Stage;
  protected bounbsBaseObject: HTMLElement;

  // Not clear that there's any other way to do this, not sure what it looks like
  // with multiple animate stages
  protected get stage() {
    return window["stage"];
  }

  protected _animateLib: any;
  public get animateLib(): any {
    return this._animateLib;
  }

  public get exportRootProxy(): AnimateProxyBase {
    return this._exportRootProxy;
  }

  public get exportRoot(): any {
    return this._exportRootProxy.stageSymbol;
  }

  constructor(exportRootLocation: string = null) {
    super(null);

    const canvas: HTMLCanvasElement = <HTMLCanvasElement>(
      document.getElementById("canvas")
    );
    if (canvas) this.setCanvas(canvas);

    this._exportRootProxy = new AnimateProxyBase(exportRootLocation);
  }

  // we know that the library exists now!
  onFrameZero() {
    const AdobeAn = window["AdobeAn"];
    this._animateLib = AdobeAn.getComposition(
      AdobeAn.bootcompsLoaded[0]
    ).getLibrary();
    this.stage.enableMouseOver(5);
  }
}

AnimateRenderSpace["Version"] = "1.0.0";

export default AnimateRenderSpace;
